<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Find your dream home
                                    <span>together</span>
                                </h1>
                                <p class="lead  text-white">Houzer lets you save all of your favourite properties, share them with friends and narrow the haystack down to the needle.</p>
                                <div class="btn-wrapper">
                                    <router-link to="/register" class="btn btn-neutral btn-icon">Get Started!</router-link>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <img src="img/houzer/pablodog.png" class="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        

    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>
